/**
 * Created by Angela Liang 07/07/2023
 *
 * Filter used for keyword search for users in users editor
 *
 */

import { Pipe, PipeTransform } from '@angular/core';
import { log } from 'util';
import { ArrayHelperService } from '../services/array-helper.service';

@Pipe({ name: 'recipientListFilter' })
export class RecipientListFilter implements PipeTransform {
    transform(recipientList, keyword: string): any {
        // Remove the check if the keyword is empty.All user should be listed in the dropdown without typing to search.
        if (!recipientList) {
            return [];
        }

        if (keyword === '') {
           ArrayHelperService.sort(recipientList, 'name');
           return recipientList;
        }
        keyword = keyword.toLowerCase();
        return recipientList.filter((user) => {
            return user.name.toLowerCase().indexOf(keyword) !== -1;
        });
    }
}
